export default __webpack_public_path__ + "static/media/queroumaagencia.a63f3298.png";